<template>
    <div class="col-md-2 sidebar">
        <h1 class="font-weight-normal pb-3">
            ADMIN: PRICING ACTIVITY WORKFLOW
            <div v-if="submission">
                <table id="stepTBL">
                    <tr v-if="activity">
                        <td><strong>ACTIVITY:</strong></td>
                        <td>{{ activity }}</td>
                    </tr>
                    <tr v-if="submission.promoString">
                        <td><strong>PROMO:</strong></td>
                        <td>{{ submission.promoString }} ({{ submission.promo_year }})</td>
                    </tr>
                    <tr v-if="submission.cust_id">
                        <td><strong>BILL-TO:</strong></td>
                        <td>{{ submission.cust_id }}</td>
                    </tr>
                    <tr v-if="submission.company">
                        <td><strong>COMPANY:</strong></td>
                        <td>{{ submission.company }}</td>
                    </tr>
                    <tr v-if="submission.prod_key">
                        <td><strong>STYLE:</strong></td>
                        <td>{{ submission.prod_key }}</td>
                    </tr>
                    <tr v-if="newPrice">
                        <td><strong>PRICING:</strong></td>
                        <td>${{ newPrice }} ({{ uom }})</td>
                    </tr>
                </table>
                <button v-if="submission.pp_status == 'n'" v-on:click="startOver()" class="btn-round-green" type="button">START OVER</button>
                <router-link v-else :to="{ name: 'PriceWorkflowDashboards', params: {dashboard: dashboardNavigationParam, status: submission.pp_status} }">
                    <button class="btn-round-green" type="button">GO TO DASHBOARD</button>
                </router-link>
            </div>
            <router-link v-else-if="!isDashboardView" :to="{ name: 'PriceWorkflowDashboards', params: {dashboard: dashboardNavigationParam} }">
                <button class="btn-round-green" type="button">GO TO DASHBOARD</button>
            </router-link>
            <router-link v-else to="/PriceWorkflowSubmission/">
                <button class="btn-round-green" type="button">Start New Submission</button>
            </router-link>
        </h1>
        <div>
            <h2 style="text-transform:none;">How to Video</h2>
            <youtube :video-id="'ViHbz79m5Vk'" ref="youtube" width="100%" height="auto"></youtube>
        </div>
        <div class="lines d-sm-none d-none d-lg-block"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activity: '',
            activityId: null,
            dashboardNavigationParam: 'PriceDeviation',
            ppId: null
        }
    },
    props: ['submission', 'newPrice', 'uom', 'isDashboardView'],
    watch: {
        submission() {
            this.activity = this.submission.activity.activity;
            this.activityId = this.submission.activity.id;
            this.ppId = this.submission.id;

            if(this.activityId == 3) {
                this.dashboardNavigationParam = 'LevelDeviation';
            } else {
                this.dashboardNavigationParam = 'PriceDeviation';
            }
        }
    },
    methods: {
        startOver() {
            axios.post(`/api/deleteSubmission`, {ppId: this.ppId}).then(response => {
                this.$router.push({
                    name: "PriceWorkflowSubmission"
                });
            });
        }
    }
}
</script>

<style scoped>
    h2 {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    #stepTBL {
        margin-top: 2rem;
        width: 100%;
        text-transform: none;
    }

    #stepTBL tr td {
        font-size: 1.2rem;
        color: #666;
        background: #fff;
        padding: 3px 0px;
    }

    #stepTBL tr td strong {
        margin-top: 0 !important;
    }
</style>